import { fetchJson } from './fetch-json';
import { HttpMethod } from './types/enum/http-method';
import { FetchRawResultType } from './types/fetch-raw-result-type';

export const fetchJsonWithToken = async ({
  token,
  uri,
  method,
  body
}: Readonly<{
  token: string;
  uri: string;
  method: HttpMethod;
  body?: object;
}>): Promise<FetchRawResultType> => fetchJson({ token, uri, method, body });
